<clr-main-container>
  <app-header></app-header>
  <app-nav-bar></app-nav-bar>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</clr-main-container>